import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'dva';
import LoadingBlocker from '../../LoadingBlocker';
import SidebarDetailHeader from '../SidebarDetailHeader';
import ImportContent from './ImportContent';
import ImportFooter from './ImportFooter';
import ImportIcon from '../../../assets/svg/ImportIcon';
import { COLORS } from '../../../lib/constants';

function ImportSidebar(props) {

  const getHeaderText = () => {
    if (!props.importError) {
      if (props.importedFeatures && props.importedFeatures.length > 0) {
        return 'Import Successful';
      } else {
        return 'Import Files';
      }
    } else {
      return 'Import Failed';
    }
  };

  return (
    <>
      { props.loading ? <LoadingBlocker /> : null }
      <SidebarDetailHeader
        title={getHeaderText()}
        titleIcon={ <ImportIcon color={COLORS.ghOrange}/>}
      />
      <ImportContent />
      <ImportFooter />
    </>
  );
}

ImportSidebar.propTypes = {
  loading: PropTypes.bool,
  importError: PropTypes.object,
  importedFeatures: PropTypes.array
};

export default connect((model) => {
  return {
    loading: model.importSidebar.loading,
    importError: model.importSidebar.importError,
    importedFeatures: model.importSidebar.importedFeatures,
  };
})(ImportSidebar);